<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col>
            <ExportSidebar
              sidebar-id="sidebar-locations-export"
              storage-key="sidebar_locations_export"
              :columns="locationsExportColumns"
              :data-to-export="items"
              :data-mapper="mapLocationForExport"
              file-name="Locations.xlsx"
              sheet-name="Locations"
              :is-busy="isBusy"
              :items-count="totalRows"
            />
          </b-col>
          <b-col cols="auto">
            <b-button id="table-settings" size="sm" variant="warning" class="mr-2" v-b-toggle.sidebar-fields>
              <font-awesome-icon icon="cog"/>
            </b-button>
            <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
              Колонки
            </b-tooltip>
            <b-btn v-if="canEditLocations()" size="sm" variant="success" :disabled="isBusy" @click="onCreate()">
              <b-spinner v-if="isBusy" small/>
              <font-awesome-icon icon="plus" class="mr-1"/>
              {{ $t("message.workers.importHand") }}
            </b-btn>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>
    <b-navbar variant="light">
      <b-navbar-nav>
        <filters-drawer
          :query.sync="filters.query"
          :is-busy="isBusy"
          :filter-tags="activeFilterTags"
          @remove-tag="removeFilterTag"
          @submit="onSearch"
          @clear="onClearFilters"
        >
          <b-col cols="12" class="mt-1">
            <label class="small text-muted">Заказчик</label>
            <customer-select
              id="input-customer-select"
              ref="customer_select"
              v-model="filters.customer_id"
              @onSelect="onSelectCustomer"
            />
          </b-col>
          <b-col md="6" cols="12">
            <label class="small text-muted">Города</label>
            <b-form-select
              id="input-town"
              size="sm"
              v-model="filters.town"
            >
              <option :value="-1">Все города</option>
              <option v-for="option in towns" :value="option.id">
                {{ option.name }}
              </option>
            </b-form-select>
          </b-col>
        </filters-drawer>
      </b-navbar-nav>
    </b-navbar>

    <b-table
      id="locations"
      ref="locations"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="renderedFields"
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"/>
          <strong>Загрузка</strong>
        </div>
      </template>
      <template #cell(action)="row">
        <b-dropdown size="sm" no-caret>
          <template #button-content>
            <font-awesome-icon icon="ellipsis-v"/>
          </template>
          <b-dropdown-item-button variant="success" @click.stop="onView(row.item)">
            <font-awesome-icon icon="eye"/>
            Смотреть
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditLocations()" variant="primary" @click="onEdit(row.item)">
            <font-awesome-icon icon="edit"/>
            Редактировать
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditLocations()" variant="danger" @click="onRemove(row)">
            <font-awesome-icon icon="trash"/>
            Удалить
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <dynamic-tables
      storage-key="locations_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      :serviceEndField="serviceEndField"
      fieldKey="id"
    />

  </div>
</template>

<script>
import locations from "../../network/locations";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import permissions, {PERM} from "../../utilites/permissions";
  import ExportSidebar from "../../utilites/commonUi/ExportSidebar.vue";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
    import CustomerSelect from "../Customers/CustomerSelect.vue";

export default {
  name: "Locations",
  components: { PaginationFooter, ExportSidebar, CustomerSelect, FiltersDrawer, DynamicTables },
  mixins: [
    locations, catalogs,
    helpers, permissions, pageSearchService
  ],
  data() {
    return {
      title: 'Объекты',
      formUrl: 'locations',
      towns: [],
      items: [],
      fields: [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          class: 'locationsId',
          visible: true,
        },
        {
          key: 'name',
          label: this.$t('message.locations.table.name'),
          sortable: true,
          visible: true,
        },
        {
          key: 'address',
          label: this.$t('message.locations.table.address'),
          sortable: true,
          visible: true,
        },
        {
          key: 'contract',
          label: this.$t('message.locations.table.contract'),
          sortable: true,
          visible: true,
        },
        {
          key: 'contact',
          label: this.$t('message.locations.table.contact'),
          sortable: true,
          visible: true,
        },
        {
          key: 'customer_name',
          label: this.$t('message.locations.table.customer_name'),
          sortable: true,
          visible: true,
        },
      ],
      serviceEndField: {
        key: 'action',
        label: this.$t('message.tasks.table.actions'),
        class: 'locationsAction'
      },
      sortBy: 'id',
      sortDesc: true,
      isBusy: false,
      filters: this.getDefaultFilters(),
      deleteRow: {
        id: null,
        name: '',
      },
      locationsExportColumns: {
        "id": true,
        "Название": true,
        "Адрес": true,
        "Договор": true,
        "Контакт": true,
        "Заказчик": true,
      },
    }
  },
  async created() {
    this.isBusy = true;
    const query = this.$route.query;

    if (query) {
      if (query.query) {
        this.filters.query = query.query;
      }

      if (query.town) {
        this.filters.town = query.town;
      }

      if (query.customer_id) {
        this.filters.customer_id = query.customer_id;
      }
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    this.towns = (await this.getTowns({})).data.items;

    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      return [
        ...this.visibleFields,
        this.serviceEndField
      ];
    },
    activeFilterTags() {
      const tags = [];
      const defaults = this.getDefaultFilters();

      if (this.filters.town !== defaults.town) {
        const foundItem = this.towns.find(s => s.id === this.filters.town);
        tags.push({ key: 'town', label: foundItem ? foundItem.name : 'Город' });
      }

      if (this.filters.customer_id !== defaults.customer_id) {
        tags.push({ key: 'customer', label: `Заказчик`,});
      }

      return tags;
    },
  },
  methods:{
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        town: this.filters.town,
        customer_id: this.filters.customer_id,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      this.isBusy = true;
      const result = await this.getLocations(data);

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
      this.isBusy = false;
    },
    onCreate() {
      this.$router.push({ name: 'LocationAdd'}).catch(()=>{});
    },
    onEdit(item) {
      this.$router.push({ name: 'LocationEdit', params: { location_id: item.id }}).catch(()=>{});
    },
    onView(item) {
      this.$router.push({ name: 'LocationView', params: { location_id: item.id}}).catch(()=>{});
    },
    onRowClicked(item) {
      if (this.hasPermission([PERM.LOCATION_EDIT])) {
        this.onEdit(item);
        return;
      }

      if (this.hasPermission([PERM.LOCATION_READ])) {
        this.onView(item);
        return;
      }
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }

      const title = this.$t('message.locations.modal.removeTitle');
      const message = `${this.$t("message.locations.modal.removeDesc")} ${this.deleteRow.name}?`;
      this.showModalDelete(title, message, async () => {
        const result = await this.deleteLocation(this.deleteRow);

        if (result.error) {
          this.showToast('Ошибка при удалении.', 'Ошибка', 'danger');
        } else {
          this.showToast('Объект удалён.', 'Успех', 'success');
          await this.getItems();
        }
      });
    },
    // Filters
    getDefaultFilters() {
      return {
        query: '',
        town: -1,
        customer_id: 0,
      };
    },
    onClearFilters() {
      const filters = this.getDefaultFilters();

      if (JSON.stringify(this.filters) === JSON.stringify(filters)) {
        return;
      }

      this.filters = filters;
      this.$refs.customer_select.onClear();
      this.onSearch();
    },
    removeFilterTag(tag) {
      if (tag.key === 'town') {
        this.filters.town = -1;
      }
      else if (tag.key === 'customer') {
        this.$refs.customer_select.onClear();
        this.filters.customer_id = 0;
      }
      this.onSearch();
    },
    onSelectCustomer(id) {
      this.filters.customer_id = id;
    },
    // Permissions
    canEditLocations() {
      return this.hasPermission([PERM.LOCATION_EDIT]);
    },
    // Export
    mapLocationForExport(item, selectedColumns) {
      const config = {
        "id": item.id,
        "Название": item.name,
        "Адрес": item.address,
        "Договор": item.contract,
        "Телефон": item.contact,
        "Заказчик": item.customer_name,
      };
      const excelData = {};

      for (const key in config) if (selectedColumns[key]) {
        excelData[key] = config[key];
      }
      return excelData;
    },
  },
}
</script>

<style>
.locationsId {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.locationsAction {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/Locations.vue